import React, { useState, useEffect } from 'react';
import { MenuItem, Select } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';
import ResultMessage from 'FielderComponents/ResultMessage';
import { isLocalUser } from 'Utils/account/utils';
import { useChangeAccount } from '../useChangeAccount';

const AccountSelect = ({ user }) => {
  const lan = useLanguage();
  const { success, data, isPending, changeAccountUser } = useChangeAccount();
  const [userOptions, setUserOptions] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [resultMessageInfo, setResultMessageInfo] = useState({
    show: false,
    message: undefined,
    success: undefined,
  });
  useEffect(() => {
    if (success === false) {
      setResultMessageInfo({ show: true, success: false, message: data });
    }
  }, [success, data, isPending]);
  useEffect(() => {
    if (user) {
      const localUser = isLocalUser(user);
      setShow(localUser && user.users != null);
      setSelectedUser(String(user.idUser));
    }
    if (user?.users?.length) {
      const options = user.users.map((element) => (
        <MenuItem value={String(element.idUser)} key={element.idUser}>
          {element.account ? element.account.name : lan.globalDashboard}
        </MenuItem>
      ));
      setUserOptions(options);
    } else {
      setUserOptions([]);
    }
  }, [user, lan]);
  const changeUser = (event) => {
    const raw = event?.target?.value ?? event?.currentTarget?.value;
    const userId = Number(raw);
    setSelectedUser(String(raw));
    const selected = user?.users?.find((u) => Number(u.idUser) === userId);
    console.log('changeUser-selectedUser:', selected);
    if (!selected) {
      console.warn('User not found for id:', userId);
      return;
    }
    changeAccountUser(selected).then((r) => console.log('changeUser-r:', r));
  };
  const closeResultMessage = () => {
    setResultMessageInfo({ show: false, message: undefined, success: undefined });
  };
  useEffect(() => {
    if (!user) {
      setShow(false);
      return;
    }
    const localUser = isLocalUser(user);
    setShow(localUser && user.users?.length > 0);
  }, [user]);
  return (
    <>
      {show ? (
        <Select
          variant="outlined"
          margin="dense"
          placeholder={lan.selectPlaceHolder}
          value={selectedUser ?? ''} // controlled
          onChange={changeUser}
          fullWidth
        >
          {userOptions}
        </Select>
      ) : null}
      {resultMessageInfo.show && (
        <ResultMessage
          onClose={closeResultMessage}
          success={resultMessageInfo.success}
          text={resultMessageInfo.message}
        />
      )}
    </>
  );
};
export default AccountSelect;
